module.exports = __webpack_public_path__ + "img/upload.27717855.svg";